module.exports = __webpack_public_path__ + "static/media/user-alt-slash.9a90fa27.svg";